import { render, staticRenderFns } from "./active_log.vue?vue&type=template&id=2dcad970&scoped=true"
import script from "./active_log.vue?vue&type=script&lang=ts"
export * from "./active_log.vue?vue&type=script&lang=ts"
import style0 from "./active_log.vue?vue&type=style&index=0&id=2dcad970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcad970",
  null
  
)

export default component.exports